import { SmartBannerEntity } from '@main/smart-banner/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { SmartBannerState, StateWithSmartBanner } from '../smart-banner-state';
import { getFeatureState } from './feature.selectors';

export const getSmartBannerState: MemoizedSelector<
  StateWithSmartBanner,
  StateUtils.LoaderState<SmartBannerEntity>
> = createSelector(getFeatureState, (state: SmartBannerState) => state.smartBanner);

export const getSmartBannerValue: MemoizedSelector<StateWithSmartBanner, SmartBannerEntity | null> = createSelector(
  getSmartBannerState,
  (state: StateUtils.LoaderState<SmartBannerEntity>) => {
    const value = StateUtils.loaderValueSelector(state);
    return value ? value : null;
  },
);

export const getSmartBannerLoading: MemoizedSelector<StateWithSmartBanner, boolean> = createSelector(
  getSmartBannerState,
  (state: StateUtils.LoaderState<SmartBannerEntity>) => StateUtils.loaderLoadingSelector(state),
);

export const getSmartBannerError: MemoizedSelector<StateWithSmartBanner, boolean> = createSelector(
  getSmartBannerState,
  (state: StateUtils.LoaderState<SmartBannerEntity>) => StateUtils.loaderErrorSelector(state),
);

export const getSmartBannerSuccess: MemoizedSelector<StateWithSmartBanner, boolean> = createSelector(
  getSmartBannerState,
  (state: StateUtils.LoaderState<SmartBannerEntity>) => StateUtils.loaderSuccessSelector(state),
);
